export const OBSERVATIONS_VIEW = {
	HOURLY: 'hourly',
	DAILY: 'daily'
};

export const LIVE_UPDATE_STATUS = {
	UNCHANGED: 0,
	UPDATED: 1,
	ERROR: 2,
	NONE: 3
};

export const initialState = () => ({
	liveData: undefined,
	freshness: 0,
	liveDataLoading: false,
	liveDataRetryCount: -1,
	liveUpdatesPaused: false,
	liveDataLoadTime: null,
	lastUpdateStatus: null,

	liveTemperature: [],
	liveWindSpeed: [],
	liveRainRate: [],

	yesterdayExtremes: undefined,
	yesterdayExtremesLoading: false,
	yesterdayExtremesRetryCount: -1,

	hourlyObservations: undefined,
	hourlyObservationsLoading: false,
	hourlyObservationsRetryCount: -1,

	dailyObservations: undefined,
	dailyObservationsLoading: false,
	dailyObservationsRetryCount: -1,

	activeObservationsView: OBSERVATIONS_VIEW.HOURLY
});

export const pauseLiveUpdates = () => ({
	liveUpdatesPaused: true
});

export const resumeLiveUpdates = () => ({
	liveUpdatesPaused: false
});

export const liveDataLoading = () => ({
	liveDataLoading: true
});

export const liveDataLoadSuccess = data => {

	const update = {
		liveDataLoading: false,
		liveDataRetryCount: -1,
		lastUpdateStatus: data === null ? LIVE_UPDATE_STATUS.UNCHANGED : LIVE_UPDATE_STATUS.UPDATED,
		liveDataLoadTime: (new Date()).getTime()
	};

	if (data !== null) {
		update.liveData = data.data;
		update.freshness = data.freshness;
	}

	return update;

};

export const liveDataLoadFailure = state => {

	const update = {
		liveDataLoading: false,
		liveDataRetryCount: state.liveDataRetryCount + 1,
		lastUpdateStatus: LIVE_UPDATE_STATUS.ERROR,
		liveDataLoadTime: (new Date()).getTime()
	};

	// Only null the data if none has been received successfully prior.
	if (state.liveData === undefined) {
		update.liveData = null;
	}

	return update;

};

export const todayHistoryLoading = () => ({
	todayHistoryLoading: true
});

export const todayHistoryLoadSuccess = data => ({
	todayHistoryLoading: false,
	todayHistoryRetryCount: -1,
	todayHistory: data
});

export const todayHistoryLoadFailure = state => ({
	todayHistoryLoading: false,
	todayHistoryRetryCount: state.todayHistoryRetryCount + 1,
	todayHistory: null
});

export const yesterdayExtremesLoading = () => ({
	yesterdayExtremesLoading: true
});

export const yesterdayExtremesLoadSuccess = data => ({
	yesterdayExtremesLoading: false,
	yesterdayExtremesRetryCount: -1,
	yesterdayExtremes: data
});

export const yesterdayExtremesLoadFailure = state => ({
	yesterdayExtremesLoading: false,
	yesterdayExtremesRetryCount: state.yesterdayExtremesRetryCount + 1,
	yesterdayExtremes: null
});

export const hourlyObservationsLoading = () => ({
	hourlyObservationsLoading: true
});

export const hourlyObservationsLoadSuccess = data => ({
	hourlyObservationsLoading: false,
	hourlyObservationsRetryCount: -1,
	hourlyObservations: data
});

export const hourlyObservationsLoadFailure = state => {

	const update = {
		hourlyObservationsLoading: false,
		hourlyObservationsRetryCount: state.hourlyObservationsRetryCount + 1
	};

	// Only null the data if none has been received successfully prior.
	if (state.hourlyObservations === undefined) {
		update.hourlyObservations = null;
	}

	return update;

};

export const dailyObservationsLoading = () => ({
	dailyObservationsLoading: true
});

export const dailyObservationsLoadSuccess = data => ({
	dailyObservationsLoading: false,
	dailyObservationsRetryCount: -1,
	dailyObservations: data
});

export const dailyObservationsLoadFailure = state => {

	const update = {
		dailyObservationsLoading: false,
		dailyObservationsRetryCount: state.dailyObservationsRetryCount + 1
	};

	// Only null the data if none has been received successfully prior.
	if (state.dailyObservations === undefined) {
		update.dailyObservations = null;
	}

	return update;

};

export const switchObservationsView = view => ({
	activeObservationsView: view
});



// WEBPACK FOOTER //
// ./routes/live/reducers.js